
  import { ref, toRefs, defineComponent, onMounted, nextTick } from 'vue'
  import uniqueString from 'unique-string'
  import { OriginatorsPublicApi } from "@/core/services/apis"

  export default defineComponent({
    name: 'Chat',
    
    props: ['originator'],

    setup(props) {
      const messages = ref<any>([])
      const newMessage = ref('')
      const scrollable = ref<any>(null)
      const conversationId = ref<any>(null)
      const loading = ref<boolean>(false)
      const { originator } = toRefs<any>(props)

      const formatTime = (timestamp) => {
        const d = new Date(timestamp)

        return String(d.getHours()).padStart(2, '0') + ':' + String(d.getMinutes()).padStart(2, '0')
      }

      const scrollToBottom = () => {
        nextTick(() => {
          if (scrollable.value) {
            scrollable.value.scrollTop = scrollable.value.scrollHeight
          }
        })
      }

      const sendMessage = () => {
        if (newMessage.value.trim() !== '') {
          loading.value = true
          messages.value.push({ sender: 'user', text: newMessage.value, timestamp: new Date() })
          socket.value.send(JSON.stringify({
            conversationId: conversationId.value,
            userMessage: newMessage.value,
            originator: originator?.value?._id || ''
          }))
          newMessage.value = ''
          scrollToBottom()
        }
      }

      const socket = ref<any>(null)

      onMounted(async () => {
        conversationId.value = localStorage.getItem('conversationId')

        if (conversationId.value) {
          try {
            const { data } = await OriginatorsPublicApi.getConversation(conversationId.value)
            messages.value = data.messages
          } catch (error) {
            localStorage.removeItem('conversationId')
          }
        }

        socket.value = new WebSocket(process.env.VUE_APP_NODE_WSS_URL)

        socket.value.onopen = () => {
          console.log('WebSocket connection opened');
        }

        socket.value.onmessage = (event) => {
          const response = JSON.parse(event.data)
          console.log(response)
          conversationId.value = response._id
          localStorage.setItem('conversationId', conversationId.value)
          messages.value = []
          messages.value = response.messages
          scrollToBottom()
          loading.value = false
        }

        scrollToBottom()
      })

      return {
        messages,
        newMessage,
        sendMessage,
        scrollable,
        formatTime,
        loading
      }
    },
  })
